import { translate } from "app/filters/i18nFilter";
import type { CrmListId } from "app/pages/sales-intelligence/domain/lists/types/list";
import type { CrmListObjectType, Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

export const getNotSyncedAllDomainsTooltipContent = (syncedDomainsCount: number, availableDomainsCount: number) => {
    return translate("si.crm-integration.not.synced.all.domains.tooltip", {
        syncedDomainsCount,
        availableDomainsCount,
    });
};

export const getCrmListName = (crm: Integration, objectType: CrmListObjectType) => {
    return translate(`si.crm-integration.${crm}.${objectType}.title`);
};

export const extractCrmAndObjectType = (id: CrmListId) => {
    const [crm, objectType] = id.split("-") as [Integration, CrmListObjectType];
    return { crm, objectType };
};

/** @deprecated import makeCrmListId from app/pages/sales-intelligence/domain/lists/utils/list-id */
export { makeCrmListId } from "app/pages/sales-intelligence/domain/lists/utils/list-id";
